import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, XCircle, Loader } from 'lucide-react';
import './Auth.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link');
        return;
      }

      try {
        const response = await axios.get(`/api/auth/verify-email/${token}`);
        setStatus('success');
        setMessage(response.data.message);
        
        // Redirect to login after 3 seconds
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Verification failed');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          {status === 'verifying' && (
            <>
              <Loader size={48} className="auth-icon spinning" />
              <h1>Verifying Email</h1>
              <p>Please wait while we verify your email address...</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <CheckCircle size={48} className="auth-icon success" />
              <h1>Email Verified!</h1>
              <p>{message}</p>
              <p className="redirect-message">Redirecting to login...</p>
            </>
          )}
          
          {status === 'error' && (
            <>
              <XCircle size={48} className="auth-icon error" />
              <h1>Verification Failed</h1>
              <p>{message}</p>
              <button 
                className="btn btn-primary btn-full"
                onClick={() => navigate('/login')}
                style={{ marginTop: '20px' }}
              >
                Go to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
